import _ from "underscore";
import styled from "styled-components";

const TableBody = ({ columns, data, onRowClick, isTableDataLoading }) => {
  const renderCell = (item, column, idx) => {
    if (column.content) return column.content(item, idx);
    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };
  return (
    <>
      {!isTableDataLoading ? (
        <>
          {data?.length > 0 ? (
            <StyledTableBody>
              {data?.map((item, idx) => (
                <StyledRow
                  isClickable={onRowClick ? true : false}
                  onClick={() => onRowClick && onRowClick(item)}
                  key={idx}
                >
                  {columns.map((column) => (
                    <td key={createKey(item, column)}>
                      <div>{renderCell(item, column, idx)}</div>
                    </td>
                  ))}
                </StyledRow>
              ))}
            </StyledTableBody>
          ) : (
            <EmptyState>
              <tr>
                <td colSpan={columns.length}>No Records Found</td>
              </tr>
            </EmptyState>
          )}
        </>
      ) : (
        <EmptyState>
          <tr>
            <td colSpan={columns.length}>Loading...</td>
          </tr>
        </EmptyState>
      )}
    </>
  );
};

const StyledTableBody = styled.tbody`
  > tr > td {
    padding: 0.813rem 0rem 0rem;
  }
`;

const StyledRow = styled.tr`
  cursor: ${(props) => (props.isClickable ? "pointer" : "default")};
`;

const EmptyState = styled.tbody`
  width: 100%;
  padding: 5rem 0;
  text-align: center;
  > tr > td {
    padding: 5rem 0;
    color: #cccccc;
  }
`;

export default TableBody;
